import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Box, Text } from '@chakra-ui/react';
import { useEmbeddedEffect } from '@machinemetrics/mm-react-embeddable';
import MMEmbeddableZoneWithLoader from 'components/MMEmbeddableZoneWithLoader';
import { APM_SELECT_JOBS_HOST } from 'lib/appConfig';

/**
 * apm-select-jobs MFE host (single or multi selectionMode).
 */
const ApmSelectJobsFlow = ({ zoneId, context, onCancel, onComplete }) => {
  const handleEmbeddedCancel = useCallback(() => {
    onCancel();
  }, [onCancel]);

  const handleJobSelected = useCallback(
    (data) => {
      window.dispatchEvent(new CustomEvent('apm:opdash-refresh'));
      if (onComplete) {
        onComplete(data);
      }
    },
    [onComplete]
  );

  useEmbeddedEffect(zoneId, 'apm-select-jobs:cancel', handleEmbeddedCancel);
  useEmbeddedEffect(zoneId, 'apm-select-jobs:job-selected', handleJobSelected);

  if (!APM_SELECT_JOBS_HOST) {
    return (
      <Box flex={1} p={6}>
        <Text color="red.500" fontWeight="medium">
          Job selection is not configured for this environment (missing
          apm-select-jobs host).
        </Text>
      </Box>
    );
  }

  return (
    <Box position="relative" flex={1} minH={0} h="full" overflow="hidden">
      <MMEmbeddableZoneWithLoader
        id={zoneId}
        src={APM_SELECT_JOBS_HOST}
        path="/"
        context={context}
      />
    </Box>
  );
};

ApmSelectJobsFlow.propTypes = {
  zoneId: PropTypes.string.isRequired,
  context: PropTypes.shape({
    machineRef: PropTypes.number,
    machineId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    erpResources: PropTypes.arrayOf(PropTypes.string),
    selectionMode: PropTypes.oneOf(['single', 'multi']).isRequired,
    eventId: PropTypes.string,
    sourceEventRefs: PropTypes.arrayOf(PropTypes.number),
  }).isRequired,
  onCancel: PropTypes.func.isRequired,
  onComplete: PropTypes.func,
};

ApmSelectJobsFlow.defaultProps = {
  onComplete: undefined,
};

export { ApmSelectJobsFlow };
